import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import Box from '@mui/material/Box';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';

import { Tabs, TabsStrategy } from '../../components/Tabs';
import { SpeedDial } from '../../components/SpeedDial';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_FOLDERS_DEFAULT,
  PATH_FOLDERS_NEW,
  PATH_FOLDERS_NOT_OPEN,
  PATH_FOLDERS_OPEN,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { OpenFolders } from './Open';
import { NotOpenFolders } from './NotOpen';

// The tab panel lays its content out in a row: the panel content takes its
// whole width, so that an empty list splash screen is centered.
const TAB_PANEL_SX = { pt: 3, width: '100%' } as const;

export const FoldersPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Folders);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Dossiers')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_FOLDERS_DEFAULT,
            label: 'dossiers',
            key: 'folders',
          },
        ]}
      />
      <PageTitle title="Liste des Dossiers" />
      <Tabs
        id="folders-tabs"
        strategy={TabsStrategy.RouterConnected}
        tabs={[
          {
            key: 'openFolders',
            label: 'Ouverts',
            panel: (
              <Box sx={TAB_PANEL_SX}>
                <OpenFolders />
              </Box>
            ),
            to: PATH_FOLDERS_OPEN,
          },
          {
            key: 'notOpenFolders',
            label: 'Archivés',
            panel: (
              <Box sx={TAB_PANEL_SX}>
                <NotOpenFolders />
              </Box>
            ),
            to: PATH_FOLDERS_NOT_OPEN,
          },
        ]}
        title="Onglets de l'écran de Liste des Dossiers"
      />
      <SpeedDial
        actions={[
          {
            id: 'createFolder',
            icon: <CreateNewFolderIcon />,
            name: 'Créer Dossier',
            to: PATH_FOLDERS_NEW,
          },
        ]}
        title="Actions possibles sur les Dossiers"
      />
    </>
  );
};
